import styled from 'vue-styled-components';

import { FLEX_VERTICAL_CENTER_DIV } from '@/styles/common.styled.component';

export const Wrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    width: 100%;
    min-height: 36px;
    max-height: 82px;
    flex-wrap: wrap;
    gap: 3px;
    padding: 2px 7px;
    overflow-y: scroll;
    background-color: #ffffff;
    border: solid 1px #cccccc;
    border-radius: 3px;
    font-size: 13px;
    color: #333333;

    input {
        min-width: 150px;
        flex: 1;
        border: none;
        outline: none;
    }
`;

export const TagItem = styled(FLEX_VERTICAL_CENTER_DIV)`
    max-width: 150px;
    height: 28px;
    justify-content: space-between;
    gap: 3px;
    padding-left: 10px;
    padding-right: 6px;
    background: #f4f6f8;
    border-radius: 2px;
`;

export const TagText = styled.div`
    flex: 1;
`;
